import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AssetTypeApi } from '../api/assetType.api';
import { switchMap, map } from 'rxjs/operators';

import { AssetTypeData, AssetType } from '../../../interfaces/masters/assetType' ;
@Injectable()
export class AssetTypeService extends AssetTypeData {

    constructor(private api: AssetTypeApi) {
      super();
    }
  
  
    list(url: string): Observable<AssetType[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<AssetType>{
        return this.api.getById(url);
    }
  
    create(url: string, data:AssetType): Observable<AssetType[]> {
      debugger;
      return this.api.add(url,data);
    }
  
    update(url: string, data:AssetType): Observable<AssetType> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  